<agm-map #map (mapClick)="onMapClick($event, mapInfoBox);" (mapReady)="onMapReady($event)"
    (mapRightClick)="onMapRightClick($event)" [disableDefaultUI]="mapSettings.disableDefaultUI" [mapTypeId]="mapTypeId"
    [maxZoom]="mapSettings.maxZoom" [minZoom]="mapSettings.minZoom" [tilt]="mapSettings.tilt"
    [restriction]="mapSettings.restriction" [streetViewControl]="mapSettings.streetViewControl"
    [zoom]="mapSettings.zoom" [fitBounds]="(searchResultMarker$ | async)?.fitBounds" [latitude]="mapSettings.latitude" [longitude]="mapSettings.longitude"
    (boundsChange)="onBoundsChange($event)" (zoomChange)="onZoomChange($event)" [styles]="customMapStyles">

    <!-- GRAY (world map) view draws the continent outline itself: the base map is white on white,
         and a data layer stays above the tile overlays so the outline survives Copernicus rasters. -->
    <agm-data-layer *ngIf="isWorldMapView" [geoJson]="worldLandGeoJson" [style]="worldLandStyle"></agm-data-layer>

    <ng-container *ngIf="mapStatus.mode === DatapointsMapMode.INTERACTION_DATASET_ACTIVE && interactiveOverlayShapes">
        <agm-data-layer [geoJson]="geometry.geojson" [style]="geometry.style"
            *ngFor="let geometry of interactiveOverlayShapes" (layerClick)="onGeojsonClick(geometry, $event)">
            <agm-info-window [latitude]="geometry.clickedLocation.lat" [longitude]="geometry.clickedLocation.lng"
                [isOpen]="geometry.showInfo" (infoWindowClose)="geometry.showInfo = false">
                {{mapStatus.externalDatasetName}}
                <div *ngFor="let property of (geometry?.geojson?.properties?.fields)">{{property.id}}:
                    {{property.value}}</div>
            </agm-info-window>
        </agm-data-layer>
    </ng-container>

    <ng-container *ngIf="regionsShapes.length > 0">
        <agm-data-layer [geoJson]="geometry.geojson" [style]="geometry.style" *ngFor="let geometry of regionsShapes">
        </agm-data-layer>
    </ng-container>

    <map-info-box #mapInfoBox (DetailsOpen)="openDetails($event)"></map-info-box>
    <!-- MEASURE    -->
    <agm-polygon
        (polyPathsChange)="updatePolygonPaths(polygon, $event, i, MapShape.POLYGON, MapDrawType.MEASURE); info.close()"
        *ngFor="let polygon of polygons.measure; let i = index" [clickable]="drawingOptions.polygon.clickable"
        [editable]="drawingOptions.polygon.editable" [fillColor]="shapeMeasurementColor"
        [geodesic]="drawingOptions.polygon.geodesic" [paths]="polygon.polygon.getPath()"
        [polyDraggable]="drawingOptions.polygon.draggable" [strokeColor]="shapeMeasurementColor"
        [strokeWeight]="drawingOptions.polygon.strokeWeight" (polyClick)="info.open()">
        <agm-info-window #info [latitude]="polygon.polygon.getPath().getArray()[0].lat()"
            [longitude]="polygon.polygon.getPath().getArray()[0].lng()" [isOpen]="false" class="info-window">
            <div class="info-box-content">
                <div style="display: flex; justify-content: space-between;">
                    <div class="tooltip-subtitle" style="color: black;">Area</div>
                    <div class="tooltip-subtitle copy-text" (click)="copyAllMeasurePolygon(polygon.polygon.getPath())">Copy All</div>
                </div>
                <hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span class="copy-text" (click)="onClickMeasurment('squareMToSquareKm', computePolygonArea(polygon.polygon.getPath()))">{{squareMToSquareKm(computePolygonArea(polygon.polygon.getPath())) | number: '1.0-2'}}&nbsp;km.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container"><span class="copy-text" (click)="onClickMeasurment('squareMToSquareMi', computePolygonArea(polygon.polygon.getPath()))">{{squareMToSquareMi(computePolygonArea(polygon.polygon.getPath())) |
                    number:
                    '1.0-2'}}&nbsp;mi.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container"><span class="copy-text" (click)="onClickMeasurment('computePolygonArea', computePolygonArea(polygon.polygon.getPath()))">{{computePolygonArea(polygon.polygon.getPath()) | number:
                    '1.0-2'}}&nbsp;m.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container"><span class="copy-text" (click)="onClickMeasurment('squareMToSquareFeet', computePolygonArea(polygon.polygon.getPath()))">{{squareMToSquareFeet(computePolygonArea(polygon.polygon.getPath())) | number:
                    '1.0-2'}}&nbsp;ft.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
            </div>
        </agm-info-window>

        <!--aeris data with coords-->
        <ng-container *ngFor="let data of polygon.polygonData | keyvalue">
            <ng-container *ngIf="data.key !== AerisType.AIR_QUALITY && data.key !== AerisType.RIVERS_GAUGES && data.key!== AerisType.STORMCELLS && data.key !== AerisType.TROPICALCYCLONES &&
                             data.key !== AerisType.ALERTS_SUMMARY && data.key !== AerisType.LIGHTNING_SUMMARY">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="data.key === AerisType.AIR_QUALITY || data.key === AerisType.RIVERS_GAUGES">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                    <div *ngFor="let trait of item.traitList; let index=index;">
                                        <div class="property-name">{{item.traitLabel}} {{index + 1}}:</div>
                                        <div *ngFor="let property of trait"><span
                                                class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                        </div>
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="data.key === AerisType.STORMCELLS || data.key === AerisType.TROPICALCYCLONES">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                    <div class="property-name">{{item.traitLabel}}</div>
                                    <div *ngFor="let trait of item.traitList">
                                        <span class="aeris-property">{{trait[0]}}</span>: {{trait[1] || '-'}}
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </agm-polygon>
    <agm-polyline (polyPathChange)="info.close();shapeUpdateDebouncer.next({ event: $event.newArr, index:i })"
        *ngFor="let polyline of polylines.measure; let i = index" [clickable]="drawingOptions.polyline.clickable"
        [editable]="false" [geodesic]="drawingOptions.polyline.geodesic"
        [polylineDraggable]="drawingOptions.polyline.draggable" [strokeColor]="drawingOptions.polyline.strokeColor"
        [strokeWeight]="drawingOptions.polyline.strokeWeight" (lineDragStart)="info.close()"
        (lineDragEnd)="getLastCoordsForInfobox($event, i, info)" (lineClick)="info.open()">
        <agm-polyline-point *ngFor="let point of polyline.polyline" [latitude]="point.lat()" [longitude]="point.lng()">
        </agm-polyline-point>
        <agm-info-window #info [latitude]="polyline.latPolylineInfobox" [longitude]="polyline.lngPolylineInfobox"
            [isOpen]="false">
            <!-- <div class="tooltip-subtitle">Distance</div> -->
            <div style="display: flex; justify-content: space-between;">
                <div class="tooltip-subtitle" style="color: black;">Distance&nbsp;&nbsp;&nbsp;</div>
                <div class="tooltip-subtitle copy-text" (click)="copyAllMeasureDistance(polyline.polyline)" >Copy All</div>
            </div>
            <div class="tooltip-value measurment-container"><span matTooltip="Click to copy"  matTooltipPosition="right"
                class="copy-text" (click)="onClickMeasurment('mToKm', computePolylineDistance(polyline.polyline))">{{mToKm(computePolylineDistance(polyline.polyline)) | number: '1.0-2'}}&nbsp;km.</span>
            </div><hr class="menu-line-separator" />
            <div class="tooltip-value measurment-container"><span matTooltip="Click to copy"  matTooltipPosition="right"
                class="copy-text" (click)="onClickMeasurment('mToMi', computePolylineDistance(polyline.polyline))">{{mToMi(computePolylineDistance(polyline.polyline)) | number: '1.0-2'}}&nbsp;mi.</span>
            </div><hr class="menu-line-separator" />
            <div class="tooltip-value measurment-container"><span matTooltip="Click to copy"  matTooltipPosition="right"
                class="copy-text" (click)="onClickMeasurment('mToMeter', computePolylineDistance(polyline.polyline))">{{mToMeter(computePolylineDistance(polyline.polyline)) | number:
                '1.0-2'}}&nbsp;m.</span>
            </div><hr class="menu-line-separator" />
            <div class="tooltip-value measurment-container"><span matTooltip="Click to copy"  matTooltipPosition="right"
                class="copy-text" (click)="onClickMeasurment('mToFeet', computePolylineDistance(polyline.polyline))">{{mToFeet(computePolylineDistance(polyline.polyline)) | number:
                '1.0-2'}}&nbsp;ft.</span>
            </div><hr class="menu-line-separator" />
        </agm-info-window>
    </agm-polyline>
    <agm-circle *ngFor="let cluster of clusters" [circleDraggable]="false" [clickable]="true" [editable]="false"
        [fillOpacity]="cluster.opacity"
        (mouseOver)="cluster.opacity = 0.8; cluster.strokeWeight = 2; cluster.showInfo = true;"
        (mouseOut)="cluster.opacity = 0.6; cluster.strokeWeight = 0.5; cluster.showInfo = false"
        (circleClick)="onClusterClick(cluster); clusterInfoWindow.open()" [fillColor]="cluster.color"
        [latitude]="cluster.center.y" [longitude]="cluster.center.x"
        [radius]="cluster.radius ? cluster.radius : clusterSettings.radius * 1000" [strokeColor]="'grey'"
        [strokeWeight]="cluster.strokeWeight" [zIndex]="10">
        <agm-info-window #clusterInfoWindow [latitude]="cluster.center.y" [longitude]="cluster.center.x"
            [isOpen]="cluster.showInfo">
            <div>{{ (clusterSettings?.selectedFieldName || clusteringField?.name) | decodeHtml }}: {{cluster?.value | commaFormat}}</div>
            <div>Count: {{cluster?.datapointsCount}}</div>
            <div style="height: 6px; width: 100%; margin-top: 8px; border-radius: 2px; opacity: 0.8;"
                [style.background]="cluster.color"></div>
        </agm-info-window>
    </agm-circle>
    <agm-circle
        (centerChange)="shapeUpdateDebouncer.next({event: {latitude: $event.lat, longitude: $event.lng, radius: circle.radius}, index:i, type: MapShape.CIRCLE, action: MapDrawType.MEASURE}); info.close()"
        (radiusChange)="shapeUpdateDebouncer.next({event: {latitude: circle.latitude, longitude: circle.longitude, radius: $event}, index:i, type: MapShape.CIRCLE, action: MapDrawType.MEASURE }); info.close()"
        *ngFor="let circle of circles.measure; let i = index" [circleDraggable]="drawingOptions.circle.draggable"
        [clickable]="drawingOptions.circle.clickable" [editable]="drawingOptions.circle.editable"
        [fillColor]="shapeMeasurementColor" [latitude]="circle.latitude" [longitude]="circle.longitude"
        [radius]="circle.radius" [strokeColor]="shapeMeasurementColor"
        [strokeWeight]="drawingOptions.circle.strokeWeight" (circleClick)="info.open()">
        <agm-info-window #info [latitude]="circle.latitude" [longitude]="circle.longitude" [isOpen]="false">
            <div class="info-box-content">
                <div style="display: flex; justify-content: space-between;">
                    <div class="tooltip-subtitle" style="color: black;">Area</div>
                    <div class="tooltip-subtitle copy-text" (click)="copyAllMeasureCircle(circle.radius)" >Copy All</div>
                </div>
                <hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container"><span
                matTooltip="Click to copy"  matTooltipPosition="right"
                class="copy-text" (click)="onClickMeasurment('squareMToSquareKm', computeCircleArea(circle.radius))">{{squareMToSquareKm(computeCircleArea(circle.radius)) | number:
                    '1.0-2'}}&nbsp;km.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('squareMToSquareMi', computeCircleArea(circle.radius))">{{squareMToSquareMi(computeCircleArea(circle.radius)) | number:
                    '1.0-2'}}&nbsp;mi.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container"><span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                class="copy-text"  (click)="onClickMeasurment('computeCircleArea', computeCircleArea(circle.radius))">{{computeCircleArea(circle.radius) | number:
                    '1.0-2'}}&nbsp;m.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span class="copy-text" (click)="onClickMeasurment('squareMToSquareFeet', computeCircleArea(circle.radius))">{{squareMToSquareFeet(computeCircleArea(circle.radius)) | number:
                        '1.0-2'}}&nbsp;ft.<sup>2</sup></span>

                    </div><hr class="menu-line-separator" />

                <div class="tooltip-subtitle">Radius</div><hr class="menu-line-separator" />
                <span class="agm-window-radius-font">
                <div class="tooltip-value">{{mToKm(circle.radius) | number: '1.0-2'}}&nbsp;km.</div><hr class="menu-line-separator" />
                <div class="tooltip-value">{{mToMi(circle.radius) | number: '1.0-2'}}&nbsp;mi.</div><hr class="menu-line-separator" />
                <div class="tooltip-value">{{mToMeter(circle.radius) | number: '1.0-2'}}&nbsp;m.</div><hr class="menu-line-separator" />
                <div class="tooltip-value">{{mToFeet(circle.radius) | number: '1.0-2'}}&nbsp;ft.</div><hr class="menu-line-separator" />
                </span>
            </div>
        </agm-info-window>
        <!--aeris data with coords-->
        <ng-container *ngFor="let data of circle.circleData | keyvalue">
            <ng-container *ngIf="data.key !== AerisType.AIR_QUALITY && data.key !== AerisType.RIVERS_GAUGES && data.key!== AerisType.STORMCELLS && data.key !== AerisType.TROPICALCYCLONES &&
                             data.key !== AerisType.ALERTS_SUMMARY && data.key !== AerisType.LIGHTNING_SUMMARY">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="data.key === AerisType.AIR_QUALITY || data.key === AerisType.RIVERS_GAUGES">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                    <div *ngFor="let trait of item.traitList; let index=index;">
                                        <div class="property-name">{{item.traitLabel}} {{index + 1}}:</div>
                                        <div *ngFor="let property of trait"><span
                                                class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                        </div>
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="data.key === AerisType.STORMCELLS || data.key === AerisType.TROPICALCYCLONES">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                    <div class="property-name">{{item.traitLabel}}</div>
                                    <div *ngFor="let trait of item.traitList">
                                        <span class="aeris-property">{{trait[0]}}</span>: {{trait[1] || '-'}}
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>

    </agm-circle>
    <agm-rectangle (boundsChange)="shapeUpdateDebouncer.next({event: $event, index:i, action: MapDrawType.MEASURE})"
        *ngFor="let rectangle of rectangles.measure; let i = index" [east]="rectangle.east"
        [editable]="drawingOptions.rectangle.editable" [fillColor]="shapeMeasurementColor" [north]="rectangle.north"
        [rectangleDraggable]="drawingOptions.rectangle.draggable" [south]="rectangle.south"
        [strokeColor]="shapeMeasurementColor" [strokePosition]="drawingOptions.strokePosition"
        [strokeWeight]="drawingOptions.rectangle.strokeWeight" [west]="rectangle.west" (rectangleClick)="info.open()">
        <agm-info-window #info [latitude]="rectangle.north" [longitude]="rectangle.east" [isOpen]="false">
            <div class="info-box-content">
                <div style="display: flex; justify-content: space-between;">
                    <div class="tooltip-subtitle" style="color: black;">Area</div>
                    <div class="tooltip-subtitle copy-text" (click)="copyAllMeasureRectangle(rectangle)" >Copy All</div>
                </div>
                <hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('squareMToSquareKm', computeRectangleArea(rectangle))">{{squareMToSquareKm(computeRectangleArea(rectangle)) | number:
                    '1.0-2'}}&nbsp;km.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('squareMToSquareMi', computeRectangleArea(rectangle))">{{squareMToSquareMi(computeRectangleArea(rectangle)) | number:
                    '1.0-2'}}&nbsp;mi.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('computeRectangleArea', computeRectangleArea(rectangle))">{{computeRectangleArea(rectangle) | number:
                    '1.0-2'}}&nbsp;m.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('squareMToSquareFeet', computeRectangleArea(rectangle))">{{squareMToSquareFeet(computeRectangleArea(rectangle)) | number:
                        '1.0-2'}}&nbsp;ft.<sup>2</sup></span>
                    </div><hr class="menu-line-separator" />
            </div>
        </agm-info-window>
        <!--aeris data with coords-->
        <ng-container *ngFor="let data of rectangle.rectangleData | keyvalue">
            <ng-container *ngIf="data.key !== AerisType.AIR_QUALITY && data.key !== AerisType.RIVERS_GAUGES && data.key!== AerisType.STORMCELLS && data.key !== AerisType.TROPICALCYCLONES &&
                             data.key !== AerisType.ALERTS_SUMMARY && data.key !== AerisType.LIGHTNING_SUMMARY">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="data.key === AerisType.AIR_QUALITY || data.key === AerisType.RIVERS_GAUGES">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                    <div *ngFor="let trait of item.traitList; let index=index;">
                                        <div class="property-name">{{item.traitLabel}} {{index + 1}}:</div>
                                        <div *ngFor="let property of trait"><span
                                                class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                        </div>
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="data.key === AerisType.STORMCELLS || data.key === AerisType.TROPICALCYCLONES">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                    <div class="property-name">{{item.traitLabel}}</div>
                                    <div *ngFor="let trait of item.traitList">
                                        <span class="aeris-property">{{trait[0]}}</span>: {{trait[1] || '-'}}
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>

    </agm-rectangle>
    <agm-rectangle (boundsChange)="shapeUpdateDebouncer.next({event: $event, index:i, action: MapDrawType.FILTER});"
        *ngFor="let rectangle of rectangles.select; let i = index" [east]="rectangle.east"
        [editable]="drawingOptions.rectangle.editable" [fillColor]="shapeSelectColor" [fillOpacity]="0.2" [north]="rectangle.north"
        [rectangleDraggable]="drawingOptions.rectangle.draggable" [south]="rectangle.south"
        [strokeColor]="shapeSelectColor" [strokePosition]="drawingOptions.strokePosition"
        [strokeWeight]="drawingOptions.rectangle.strokeWeight" [west]="rectangle.west" [clickable]="false">
        <agm-info-window #info [latitude]="rectangle.north" [longitude]="rectangle.east" [isOpen]="false">
            <div class="info-box-content">
                <div style="display: flex; justify-content: space-between;">
                    <div class="tooltip-subtitle" style="color: black;">Area</div>
                    <div class="tooltip-subtitle copy-text" (click)="copyAllMeasureRectangle(rectangle)" >Copy All</div>
                </div>
                <hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                     class="copy-text" (click)="onClickMeasurment('squareMToSquareKm', computeRectangleArea(rectangle))">{{squareMToSquareKm(computeRectangleArea(rectangle)) |
                    number:'1.0-2'}}&nbsp;km.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('squareMToSquareMi', computeRectangleArea(rectangle))">{{squareMToSquareMi(computeRectangleArea(rectangle)) |
                    number:'1.0-2'}}&nbsp;mi.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('computeRectangleArea', computeRectangleArea(rectangle))">{{computeRectangleArea(rectangle) | number:
                    '1.0-2'}}&nbsp;m.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                     class="copy-text" (click)="onClickMeasurment('squareMToSquareFeet', computeRectangleArea(rectangle))">{{squareMToSquareFeet(computeRectangleArea(rectangle)) | number:
                    '1.0-2'}}&nbsp;ft.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
            </div>
        </agm-info-window>
        <!--aeris data with coords-->
        <ng-container *ngFor="let data of rectangle.rectangleData | keyvalue">
            <ng-container *ngIf="data.key !== AerisType.AIR_QUALITY && data.key !== AerisType.RIVERS_GAUGES && data.key!== AerisType.STORMCELLS && data.key !== AerisType.TROPICALCYCLONES &&
                             data.key !== AerisType.ALERTS_SUMMARY && data.key !== AerisType.LIGHTNING_SUMMARY">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="data.key === AerisType.AIR_QUALITY || data.key === AerisType.RIVERS_GAUGES">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                    <div *ngFor="let trait of item.traitList; let index=index;">
                                        <div class="property-name">{{item.traitLabel}} {{index + 1}}:</div>
                                        <div *ngFor="let property of trait"><span
                                                class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                        </div>
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="data.key === AerisType.STORMCELLS || data.key === AerisType.TROPICALCYCLONES">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                    <div class="property-name">{{item.traitLabel}}</div>
                                    <div *ngFor="let trait of item.traitList">
                                        <span class="aeris-property">{{trait[0]}}</span>: {{trait[1] || '-'}}
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>

    </agm-rectangle>

    <!-- FILTER    -->
    <agm-polygon
        (polyPathsChange)="onPathsChange(polygon, $event, i, MapShape.POLYGON, MapDrawType.FILTER); info.close()"
        *ngFor="let polygon of polygons.select; let i = index" [clickable]="false"
        [editable]="polygon.isEditable" [fillColor]="shapeSelectColor" [fillOpacity]="0.2"
        [geodesic]="drawingOptions.polygon.geodesic" [paths]="polygon.polygon.getPath()"
        [polyDraggable]="true" [strokeColor]="shapeSelectColor"
        [strokeWeight]="drawingOptions.polygon.strokeWeight"
        (polyRightClick)="onPolygonRightClick(i, polygon, $event)"
        (polyDrag)="onPolygonDrag($event, i)"
        (polyDragEnd)="onPolygonDragEnd(polygon.polygon, i)"
        >
        <agm-info-window #info [latitude]="polygon.polygon.getPath().getArray()[0].lat()"
            [longitude]="polygon.polygon.getPath().getArray()[0].lng()" [isOpen]="false">
            <div class="info-box-content">
                <div style="display: flex; justify-content: space-between;">
                    <div class="tooltip-subtitle" style="color: black;">Area</div>
                    <div class="tooltip-subtitle copy-text" (click)="copyAllMeasurePolygon(polygon.polygon.getPath())">Copy All</div>
                </div>
                <hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('squareMToSquareKm', computePolygonArea(polygon.polygon.getPath()))">{{squareMToSquareKm(computePolygonArea(polygon.polygon.getPath())) |
                    number:'1.0-2'}}&nbsp;km.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('squareMToSquareMi', computePolygonArea(polygon.polygon.getPath()))">{{squareMToSquareMi(computePolygonArea(polygon.polygon.getPath())) |
                    number:'1.0-2'}}&nbsp;mi.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('computePolygonArea', computePolygonArea(polygon.polygon.getPath()))">{{computePolygonArea(polygon.polygon.getPath()) | number:
                    '1.0-2'}}&nbsp;m.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('squareMToSquareFeet', computePolygonArea(polygon.polygon.getPath()))">{{squareMToSquareFeet(computePolygonArea(polygon.polygon.getPath())) | number:
                    '1.0-2'}}&nbsp;ft.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
            </div>
        </agm-info-window>
        <agm-info-window #vertexInfo [latitude]="vertexInfoLat" [longitude]="vertexInfoLng" [isOpen]="false">
            <div class="vertex-info-inner" *ngIf="selectedPolygonIndex >= 0">
                <mat-slide-toggle class="vertex-info-inner" (change)="onRotateToggleChange($event)" [checked]="polygonLocked[selectedPolygonIndex]" color="accent">
                    Rotate
                </mat-slide-toggle>
            </div>
        </agm-info-window>

        <!--aeris data with coords-->
        <ng-container *ngFor="let data of polygon.polygonData | keyvalue">
            <ng-container *ngIf="data.key !== AerisType.AIR_QUALITY && data.key !== AerisType.RIVERS_GAUGES && data.key!== AerisType.STORMCELLS && data.key !== AerisType.TROPICALCYCLONES &&
                             data.key !== AerisType.ALERTS_SUMMARY && data.key !== AerisType.LIGHTNING_SUMMARY">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="data.key === AerisType.AIR_QUALITY || data.key === AerisType.RIVERS_GAUGES">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                    <div *ngFor="let trait of item.traitList; let index=index;">
                                        <div class="property-name">{{item.traitLabel}} {{index + 1}}:</div>
                                        <div *ngFor="let property of trait"><span
                                                class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                        </div>
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="data.key === AerisType.STORMCELLS || data.key === AerisType.TROPICALCYCLONES">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                    <div class="property-name">{{item.traitLabel}}</div>
                                    <div *ngFor="let trait of item.traitList">
                                        <span class="aeris-property">{{trait[0]}}</span>: {{trait[1] || '-'}}
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>

    </agm-polygon>

    <!-- Info icon markers for polygons -->
    <ng-container *ngFor="let polygon of polygons.select; let i = index">
        <agm-marker
            #polygonIconMarkers
            [latitude]="getPolygonTopRight(polygon).lat"
            [longitude]="getPolygonTopRight(polygon).lng"
            [iconUrl]="getShapeInfoIconUrl(polygonIconHover[i])"
            [zIndex]="1000"
            [markerDraggable]="true"
            (markerClick)="onPolygonIconClick(i)"
            (markerRightClick)="onPolygonIconRightClick(i)"
            (dragStart)="onPolygonIconDragStart(i)"
            (drag)="onPolygonIconDrag($event, i)"
            (dragEnd)="onPolygonIconDragEnd($event, i)"
            (mouseOver)="polygonIconHover[i] = true"
            (mouseOut)="polygonIconHover[i] = false">
        </agm-marker>
    </ng-container>

    <agm-circle
        (centerChange)="shapeUpdateDebouncer.next({event: {latitude: $event.lat, longitude: $event.lng, radius: circle.radius}, index:i, type: MapShape.CIRCLE, action: MapDrawType.FILTER}); info.close()"
        (radiusChange)="shapeUpdateDebouncer.next({event: {latitude: circle.latitude, longitude: circle.longitude, radius: $event}, index:i, type: MapShape.CIRCLE, action: MapDrawType.FILTER}); info.close()"
        *ngFor="let circle of circles.select; let i = index"
        [circleDraggable]="true"
        [clickable]="false"
        [editable]="false"
        [fillOpacity]="0.05" [latitude]="circle.latitude" [longitude]="circle.longitude"
        [radius]="circle.radius" [strokeColor]="shapeSelectColor" [strokeWeight]="1"
        [zIndex]="-1">
        <agm-info-window #info [latitude]="circle.latitude" [longitude]="circle.longitude" [isOpen]="false">
            <div class="info-box-content">
                <div style="display: flex; justify-content: space-between;">
                    <div class="tooltip-subtitle" style="color: black;">Area</div>
                    <div class="tooltip-subtitle copy-text" (click)="copyAllMeasureCircle(circle.radius)">Copy All</div>
                </div>
                <hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('computeCircleArea', circle.radius)">{{computeCircleArea(circle.radius) | number:'1.0-2'}}&nbsp;m.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('squareMToSquareKm', computeCircleArea(circle.radius))">{{squareMToSquareKm(computeCircleArea(circle.radius)) | number:'1.0-2'}}&nbsp;km.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('squareMToSquareMi', computeCircleArea(circle.radius))">{{squareMToSquareMi(computeCircleArea(circle.radius)) | number:'1.0-2'}}&nbsp;mi.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                     class="copy-text" (click)="onClickMeasurment('squareMToSquareFeet', computeCircleArea(circle.radius))">{{squareMToSquareFeet(computeCircleArea(circle.radius)) | number:'1.0-2'}}&nbsp;ft.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
            </div>
        </agm-info-window>
    </agm-circle>

    <!-- Info icon markers for circles (template-based) -->
    <!-- Debug: Circles count = {{circles?.select?.length || 0}} -->
    <ng-container *ngFor="let circle of circles.select; let i = index">
        <!-- Debug: Creating marker for circle {{i}} at lat={{getCircleTopRight(circle).lat}}, lng={{getCircleTopRight(circle).lng}} -->
        <agm-marker
            [latitude]="getCircleTopRight(circle).lat"
            [longitude]="getCircleTopRight(circle).lng"
            [iconUrl]="getShapeInfoIconUrl(circleIconHover[i])"
            [zIndex]="1000"
            [markerDraggable]="false"
            [visible]="true"
            (markerClick)="onCircleIconClick(i)"
            (mouseOver)="circleIconHover[i] = true"
            (mouseOut)="circleIconHover[i] = false">
        </agm-marker>
    </ng-container>
    
    <!-- Info icon markers for custom circles (programmatic) -->
    <!-- Debug: Custom circles count = {{getCustomCirclesCount()}} -->

    <agm-rectangle (boundsChange)="shapeUpdateDebouncer.next({event: $event, index:i, action: MapDrawType.FILTER});"
        *ngFor="let rectangle of rectangles.select; let i = index" [east]="rectangle.east"
        [editable]="drawingOptions.rectangle.editable" [fillColor]="shapeSelectColor" [fillOpacity]="0.2" [north]="rectangle.north"
        [rectangleDraggable]="true" [south]="rectangle.south"
        [strokeColor]="shapeSelectColor" [strokePosition]="drawingOptions.strokePosition"
        [strokeWeight]="drawingOptions.rectangle.strokeWeight" [west]="rectangle.west" [clickable]="false">
        <agm-info-window #info [latitude]="rectangle.north" [longitude]="rectangle.east" [isOpen]="false">
            <div class="info-box-content">
                <div style="display: flex; justify-content: space-between;">
                    <div class="tooltip-subtitle" style="color: black;">Area</div>
                    <div class="tooltip-subtitle copy-text" (click)="copyAllMeasureRectangle(rectangle)" >Copy All</div>
                </div>
                <hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                     class="copy-text" (click)="onClickMeasurment('squareMToSquareKm', computeRectangleArea(rectangle))">{{squareMToSquareKm(computeRectangleArea(rectangle)) |
                    number:'1.0-2'}}&nbsp;km.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('squareMToSquareMi', computeRectangleArea(rectangle))">{{squareMToSquareMi(computeRectangleArea(rectangle)) |
                    number:'1.0-2'}}&nbsp;mi.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                    class="copy-text" (click)="onClickMeasurment('computeRectangleArea', computeRectangleArea(rectangle))">{{computeRectangleArea(rectangle) | number:
                    '1.0-2'}}&nbsp;m.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
                <div class="tooltip-value font-12 measurment-container">
                    <span
                    matTooltip="Click to copy"  matTooltipPosition="right"
                     class="copy-text" (click)="onClickMeasurment('squareMToSquareFeet', computeRectangleArea(rectangle))">{{squareMToSquareFeet(computeRectangleArea(rectangle)) | number:
                    '1.0-2'}}&nbsp;ft.<sup>2</sup></span>
                </div><hr class="menu-line-separator" />
            </div>
        </agm-info-window>
        <!--aeris data with coords-->
        <ng-container *ngFor="let data of rectangle.rectangleData | keyvalue">
            <ng-container *ngIf="data.key !== AerisType.AIR_QUALITY && data.key !== AerisType.RIVERS_GAUGES && data.key!== AerisType.STORMCELLS && data.key !== AerisType.TROPICALCYCLONES &&
                             data.key !== AerisType.ALERTS_SUMMARY && data.key !== AerisType.LIGHTNING_SUMMARY">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="data.key === AerisType.AIR_QUALITY || data.key === AerisType.RIVERS_GAUGES">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                    <div *ngFor="let trait of item.traitList; let index=index;">
                                        <div class="property-name">{{item.traitLabel}} {{index + 1}}:</div>
                                        <div *ngFor="let property of trait"><span
                                                class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                        </div>
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="data.key === AerisType.STORMCELLS || data.key === AerisType.TROPICALCYCLONES">
                <ng-container *ngIf="data.value.length > 0">
                    <ng-container *ngIf="data.value[0].showData">
                        <agm-marker *ngFor="let item of data.value" [latitude]="item.loc.lat"
                            [longitude]="item.loc.long" [zIndex]="1000">
                            <agm-info-window>
                                <div class="locations-aeris-container">
                                    <div class="poi-name">{{item.type}}</div>
                                    <div *ngFor="let property of item.properties">
                                        <span class="aeris-property">{{property[0]}}</span>: {{property[1] || '-'}}
                                    </div>
                                    <div class="property-name">{{item.traitLabel}}</div>
                                    <div *ngFor="let trait of item.traitList">
                                        <span class="aeris-property">{{trait[0]}}</span>: {{trait[1] || '-'}}
                                    </div>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>

    </agm-rectangle>

    <!-- Info icon markers for rectangles -->
    <ng-container *ngFor="let rectangle of rectangles.select; let i = index">
        <agm-marker
            [latitude]="getRectangleTopRight(rectangle).lat"
            [longitude]="getRectangleTopRight(rectangle).lng"
            [iconUrl]="getShapeInfoIconUrl(rectangleIconHover[i])"
            [zIndex]="1000"
            [markerDraggable]="true"
            (markerClick)="onRectangleIconClick(i)"
            (dragStart)="onRectangleIconDragStart(i)"
            (drag)="onRectangleIconDrag($event, i)"
            (dragEnd)="onRectangleIconDragEnd($event, i)"
            (mouseOver)="rectangleIconHover[i] = true"
            (mouseOut)="rectangleIconHover[i] = false">
        </agm-marker>
    </ng-container>

    <agm-marker *ngIf="activeMarker" [latitude]="activeMarker.y" [longitude]="activeMarker.x"
        [markerDraggable]="activeMarkerEditMode" (dragStart)="markerAnimation = null"
        (dragEnd)="markerAnimation = 'BOUNCE'; activeMarker.x = $event.coords.lng; activeMarker.y = $event.coords.lat"
        [animation]="markerAnimation">
    </agm-marker>

    <agm-marker *ngIf="searchResultMarker$ | async as marker" [latitude]="marker.latitude"
        [longitude]="marker.longitude" [markerDraggable]="true"
        [iconUrl]="getDefaultIconUrl()"
        (dragEnd)="marker.latitude = $event.coords.lat; marker.longitude = $event.coords.lng; updateAddressOnDragEnd($event.coords.lat,$event.coords.lng)">
    </agm-marker>
    <agm-polygon *ngIf="preciselyWildfirePolygonData" [clickable]="false" [editable]="false"
        [fillColor]="shapeSelectColor" [fillOpacity]="0.18" [paths]="preciselyWildfirePolygonData.paths"
        [polyDraggable]="false" [strokeColor]="shapeSelectColor" [strokeOpacity]="0.9" [strokeWeight]="2">
    </agm-polygon>
    <agm-polygon #polygonElement *ngIf="preciselyPolygonData" [clickable]="drawingOptions.polygon.clickable"
        [editable]="false" [fillColor]="shapeSelectColor" [geodesic]="drawingOptions.polygon.geodesic"
        [paths]="preciselyPolygonData.paths" [polyDraggable]="false" [strokeColor]="shapeSelectColor"
        [strokeWeight]="drawingOptions.polygon.strokeWeight">
    </agm-polygon>
    <!--
        Location Profile boundary polygons (e.g. the Census block group behind Precisely Crime).
        Lighter fill and a dashed-looking thin stroke than the Footprint polygon above: this is an
        area a location sits inside, not the building itself, so it should read as context rather
        than as the subject.
    -->
    <agm-polygon *ngFor="let entry of profilePolygonService.polygons | keyvalue" [clickable]="false"
        [editable]="false" [fillColor]="profileBoundaryColor" [fillOpacity]="0.08"
        [geodesic]="drawingOptions.polygon.geodesic" [paths]="entry.value.paths" [polyDraggable]="false"
        [strokeColor]="profileBoundaryColor" [strokeOpacity]="0.9" [strokeWeight]="2">
    </agm-polygon>
</agm-map>
<div class="map-custom-actions">
    <div class="flex custom-wrapper">
        <div *ngIf="showSearchInfo" class="google-search-wrapper">
        <div>
            <mat-icon fontIcon="fa-search" fontSet="fas" class="search-icon"></mat-icon>
        </div>
        <div>
            <input class="custom-ip-search-info" matGoogleMapsAutocomplete placeholder="Enter an address.." [value]="currentPinAddress | async"
                [(ngModel)]="address" (onAutocompleteSelected)="onSearchAutocompleteSelected($event)"
                (onLocationSelected)="onSearchLocationSelected($event)">
        </div>
        <div class="info-icon-wrap" (click)="seeAddressDetails()">
            <mat-icon fontIcon="fa-info-square" fontSet="fal" class="info-icon"></mat-icon>
        </div>
        </div>
    </div>
    <div class="map-btns-group">
        <mat-button-toggle-group [value]="mapType">
            <mat-button-toggle *ngFor="let mapOption of mapOption" [value]="mapOption" class="map-button">
                <div class="toggle-btn-content">
                    <img [src]="mapOption.iconSource" class="map-image" alt="maps" (click)="onIconClick(mapOption.type)">
                </div>
                <div class="toggle-btn-text" [class.world-map-text]="mapOption.type === 'world_map'">
                    {{ mapOption.displayName || (mapOption.type.replace('_', ' ') | uppercase) }}
                </div>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>

</div>

<div class="map-play-button" *ngIf="showPlayButton">
    <div>
        <button mat-fab class="play-button" color="primary" (click)="toggleInteractiveMapAnimation()">
            <mat-icon fontIcon="fa-play" fontSet="fas"></mat-icon>
        </button>

        <button mat-fab color="primary" (click)="toggleInteractiveMapAnimation()">
            <mat-icon fontIcon="fa-stop" fontSet="fas"></mat-icon>
        </button>
    </div>
</div>
